var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-content" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c(
        "div",
        {
          staticClass: "h5 mb-0 modal-title d-flex align-center",
          attrs: { id: "commentModalLabel" },
          on: { click: _vm.onBack },
        },
        [
          _c("i", { staticClass: "bi bi-chevron-left" }),
          _vm._v(" "),
          _c("span", { staticClass: "body-1" }, [_vm._v("戻る")]),
        ]
      ),
      _vm._v(" "),
      _vm.showCloseButton
        ? _c("button", {
            staticClass: "btn-close",
            attrs: {
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
            },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.currentQuession
      ? _c(
          "div",
          { staticClass: "modal-body" },
          [
            _vm._t("notice"),
            _vm._v(" "),
            _c(
              "article",
              { staticClass: "pb-5 mb-4" },
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          class: {
                            "success dark": _vm.currentQuession.voteMark == 1,
                          },
                          attrs: { fab: "", small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.upVote(
                                _vm.currentQuession.voteMark,
                                _vm.currentQuession.id,
                                "Question"
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("keyboard_arrow_up"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "vote-value" }, [
                        _vm._v(_vm._s(_vm.currentQuession.voteMark)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          class: {
                            "success dark": _vm.currentQuession.voteMark == -1,
                          },
                          attrs: { fab: "", small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.downVote(
                                _vm.currentQuession.voteMark,
                                _vm.question.id,
                                "Question"
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("keyboard_arrow_down"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col pt-0" }, [
                    _c("h2", { staticClass: "fs-5 fw-bold mb-1" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.currentQuession.title) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "small mb-0" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.dateFormat(_vm.currentQuession.createdAt)
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "my-3" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-5" }, [
                      _c("div", {
                        staticClass: "mb-4 html-body",
                        domProps: {
                          innerHTML: _vm._s(_vm.currentQuession.renderedBody),
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row align-items-center question-info" },
                  [
                    _vm.currentQuession.user
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col text-end v-list-item__subtitle question-info-user",
                          },
                          [
                            _vm.currentQuession.user.image
                              ? _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: {
                                    src: _vm.currentQuession.user.image.url,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.currentQuession.user.name)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "ps-0" },
                  _vm._l(_vm.currentQuession.comments, function (comment) {
                    return _c(
                      "li",
                      {
                        key: comment.id,
                        staticClass: "row pt-5",
                        attrs: { id: "comment-" + comment.id },
                      },
                      [
                        _c("div", { staticClass: "question-answer-img" }, [
                          comment.user.image
                            ? _c("img", {
                                staticClass: "img-fluid",
                                attrs: { src: comment.user.image.url },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col pt-0 ps-1" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-wrap justify-content-between align-items-center",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "grey--text pe-4 mb-1" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(comment.user.name) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "primary--text text-end small mb-1",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.dateFormat(comment.createdAt)
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "my-4" }, [
                            _c("div", {
                              staticClass: "html-body",
                              domProps: {
                                innerHTML: _vm._s(comment.renderedBody),
                              },
                            }),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("CommentCreation", {
                  attrs: {
                    showCommentForm: _vm.currentQuession.showCommentForm,
                    onCancel: function () {
                      _vm.currentQuession.showCommentForm = false
                    },
                    onOpen: function () {
                      _vm.currentQuession.showCommentForm = true
                    },
                    createComment: function (newComment) {
                      _vm.createComment(newComment)
                    },
                  },
                  on: {
                    "update:showCommentForm": function ($event) {
                      return _vm.$set(
                        _vm.currentQuession,
                        "showCommentForm",
                        $event
                      )
                    },
                    "update:show-comment-form": function ($event) {
                      return _vm.$set(
                        _vm.currentQuession,
                        "showCommentForm",
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "h3",
                      { ref: "toggleAnswerLabel", staticClass: "fw-bold" },
                      [_vm._v("アンサーを投稿する")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { fab: "", dark: "", small: "", color: "teal" },
                        on: {
                          click: function ($event) {
                            _vm.answerToggle = !_vm.answerToggle
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { dark: "" } }, [
                          _vm._v("mdi-plus"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.answerToggle
                  ? [
                      _c("Simplemde", {
                        attrs: { rows: 3, name: "answer-body" },
                        model: {
                          value: _vm.newAnswer,
                          callback: function ($$v) {
                            _vm.newAnswer = $$v
                          },
                          expression: "newAnswer",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-file-input", {
                                attrs: {
                                  label: "素材をアップロード",
                                  multiple: "",
                                  "prepend-icon": "mdi-paperclip",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var text = ref.text
                                        return [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                small: "",
                                                label: "",
                                                color: "primary",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(text) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3745244224
                                ),
                                model: {
                                  value: _vm.answerFiles,
                                  callback: function ($$v) {
                                    _vm.answerFiles = $$v
                                  },
                                  expression: "answerFiles",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-5" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn rounded-pill bg-dark text-white",
                            attrs: { type: "button" },
                            on: { click: _vm.createAnswer },
                          },
                          [_vm._v("\n            アンサーする\n          ")]
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.currentQuession.userAnswers.length > 0
              ? [
                  _c("h3", { staticClass: "h6 fw-bold" }, [
                    _vm._v("アンサー一覧"),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "ps-0" },
                    _vm._l(_vm.currentQuession.userAnswers, function (answer) {
                      return _c(
                        "li",
                        {
                          key: answer.id,
                          staticClass: "row my-5",
                          attrs: { id: "answer-" + answer.id },
                        },
                        [
                          _c("div", { staticClass: "question-answer-img" }, [
                            answer.user.image
                              ? _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: { src: answer.user.image.url },
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col pt-0 ps-1" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-wrap justify-content-between align-items-center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "grey--text pe-4 mb-1" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(answer.user.name) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "primary--text text-end small mb-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.dateFormat(answer.createdAt)
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "my-4" }, [
                              _c("div", {
                                staticClass: "html-body",
                                domProps: {
                                  innerHTML: _vm._s(answer.renderedBody),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "ps-0" },
                              _vm._l(answer.comments, function (comment) {
                                return _c(
                                  "li",
                                  {
                                    key: comment.id,
                                    staticClass: "row pt-5",
                                    attrs: { id: "comment-" + comment.id },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "question-answer-img" },
                                      [
                                        comment.user.image
                                          ? _c("img", {
                                              staticClass: "img-fluid",
                                              attrs: {
                                                src: comment.user.image.url,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col pt-0 ps-1" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-wrap justify-content-between align-items-center",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "grey--text pe-4 mb-1",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(comment.user.name) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "primary--text text-end small mb-1",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.dateFormat(
                                                        comment.createdAt
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "my-4" }, [
                                          _c("div", {
                                            staticClass: "html-body",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                comment.renderedBody
                                              ),
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mt-3 py-2" },
                              [
                                _c("CommentCreation", {
                                  attrs: {
                                    showCommentForm: answer.showCommentForm,
                                    onCancel: function () {
                                      answer.showCommentForm = false
                                    },
                                    onOpen: function () {
                                      answer.showCommentForm = true
                                    },
                                    createComment: function (newComment) {
                                      _vm.createAnswerComment(
                                        newComment,
                                        answer
                                      )
                                    },
                                  },
                                  on: {
                                    "update:showCommentForm": function (
                                      $event
                                    ) {
                                      return _vm.$set(
                                        answer,
                                        "showCommentForm",
                                        $event
                                      )
                                    },
                                    "update:show-comment-form": function (
                                      $event
                                    ) {
                                      return _vm.$set(
                                        answer,
                                        "showCommentForm",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }